define('modules/start/products/landings/index',['require','exports','module','./status/model','../base/view','./logobutton/view','./activity/view','./status/view','./info/view'],function (require, exports, module) {
    "use strict";

    var DetailsModel = require("./status/model");

    module.exports = {
        View: require("../base/view"),
        detailsModel: new DetailsModel(),
        LogoButtonView: require("./logobutton/view"),
        ActivityView: require("./activity/view"),
        StatusView: require("./status/view"),
        InfoView: require("./info/view")
    };
});

